import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@shared/hooks/use-toast';
import { useTranslation } from 'react-i18next';
import { ExtraWorkOrdersApiAdapter } from '../../List/adapters/ExtraWorkOrdersApiAdapter';

/**
 * Hook para gestionar el flujo de despacho en trabajos extra
 */
export const useExtraWorkDispatch = (orderId: number | null) => {
    const queryClient = useQueryClient();
    const { toast } = useToast();
    const { t } = useTranslation('extraWorkOrdersModule');
    const httpClient = createHttpClient(apiClientWH);
    const apiAdapter = new ExtraWorkOrdersApiAdapter(httpClient);

    // Mutación para realizar el despacho
    const dispatchMutation = useMutation({
        mutationFn: (data: any) => {
            console.log('🔄 useExtraWorkDispatch - Ejecutando mutationFn:', { orderId, data });
            if (!orderId) throw new Error('Order ID is required');
            return apiAdapter.dispatchByLocation(orderId, data);
        },
        onSuccess: () => {
            console.log('✅ useExtraWorkDispatch - Mutation onSuccess');
            queryClient.invalidateQueries({ queryKey: ['extra-work-order', orderId] });
            queryClient.invalidateQueries({ queryKey: ['extra-work-carts', orderId] });
            queryClient.invalidateQueries({ queryKey: ['extra-work-pending-locations', orderId] });
            
            toast({
                title: t('toasts.dispatchSuccess.title', 'Despacho realizado'),
                description: t('toasts.dispatchSuccess.description', 'El carrito se ha despachado correctamente'),
                variant: 'default',
            });
        },
        onError: (error: any) => {
            console.error('❌ useExtraWorkDispatch - Mutation onError:', error);
            const errorMessage = error?.response?.data?.message || error?.message || t('toasts.error.unexpected', 'Error inesperado');
            toast({
                title: t('toasts.error.title', 'Error'),
                description: errorMessage,
                variant: 'destructive',
            });
        }
    });

    return {
        dispatchCart: dispatchMutation.mutateAsync,
        isDispatching: dispatchMutation.isPending,
    };
};
